module.exports = __webpack_public_path__ + "static/media/SAUTER.f5bbbf24.pdf";